import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

export const PymtList = ({ payeeCustId }) => {
  const { domain } = useParams();

  const augRowsReq = useCallback(
    (rowsReq) => {
      if (domain) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('domain', domain.toUpperCase()));
      }

      if (payeeCustId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('payeeCustId', payeeCustId));
      }
    },
    [domain, payeeCustId],
  );

  return <EntityList module="sc" entity="PYMT" augRowsReq={augRowsReq} />;
};
